import React, { useEffect, useState } from 'react'
import styles from "./Myproject.module.css"
import Modal from './Modal';
import { create_project_Api, delete_project_Api, get_all_environment_Api, get_all_project_Api, getLatestProjectPdf, getLatestProjectXML, update_project_Api } from '../../dashboardapi';
import { useParams } from 'react-router-dom';
// import data from "../../json/Config.json"
import { Link } from 'react-router-dom';
import { Spinner, useToast } from '@chakra-ui/react';
import { downloadFile, downloadURI } from '../../Utils/utils';
import { wrap } from 'lodash';

const Myproject = () => {
    // const [projectlen, setProjectLen] = useState(0);
    const [showmodal, setShowModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [projectTitle, setProjectTitle] = useState({ name: "", env: "", date: "" });
    const [projects, setProjects] = useState([]);

    const [updatedata, setUpdatedata] = useState("");
    const [environment, setEnvironments] = useState([]);

    const pdfIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-file-earmark-pdf" viewBox="0 0 16 16"><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" /><path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" /></svg>
    const xmlIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-filetype-xml" viewBox="0 0 16 16"><path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2v-1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.527 11.85h-.893l-.823 1.439h-.036L.943 11.85H.012l1.227 1.983L0 15.85h.861l.853-1.415h.035l.85 1.415h.908l-1.254-1.992zm.954 3.999v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596h-.025L4.58 11.85h-.806v3.999zm4.71-.674h1.696v.674H8.4V11.85h.791z" /></svg>
    const templateIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>
    const { project } = useParams();

    const toast = useToast();

    useEffect(() => {
        if (project === 'myprojects') {
            fetchprojectapi();
        }
    }, [])

    useEffect(() => {
        getallenvironments()
    }, [showUpdateModal, showmodal])


    const getallenvironments = async () => {
        try {
            let response = await get_all_environment_Api();
            if (response.data) {
                setEnvironments(response.data)
            } else {
                let error = response.error.Message || "An error Occurred"
                toast({
                    title: "Problem getting Environmentfiles",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem getting Environmentfiles",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }
    //MARK:fetch project
    const fetchprojectapi = async () => {
        toast({
            title: "Fetching projects",
            description: "Your projects are being fetched",
            status: "info",
            isClosable: "true"
        })
        let response = await get_all_project_Api();

        //console.log(response.data.projects);

        if (response.data !== null) {
            toast.closeAll()
            setProjects(response.data.projects)

        } else {
            toast({
                title: "No projects found",
                description: "error",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleChange = (e) => {
        setProjectTitle({ name: e.target.value })
    }
    //MARK:create project
    const createFile = async (e) => {
        e.preventDefault();
        let result = await create_project_Api(projectTitle.name, projectTitle.env)
        // console.log(result)
        if (result.data) {
            setShowModal(false)
            toast({
                title: " Project created successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchprojectapi();
        } else {
            if (result) {
                const errorMessage = result.error.message || "An error occurred.";
                toast({
                    title: "Problem creating project",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        }
    }
    //MARK:update project
    const updateProject = async (e) => {
        e.preventDefault();
        // console.log(updatedata);
        let result = await update_project_Api(updatedata.id, updatedata.name, updatedata.env_name);
        if (result.data) {
            toast({
                title: "Updated project details",
                description: "Project details updated successfully",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            setShowUpdateModal(false);
            fetchprojectapi()
        } else {
            let error = result.error.message || "An error Occurred"
            toast({
                title: "Problem updating project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleDelete = async (id) => {
        let result = await delete_project_Api(id);
        if (result.data) {
            toast({
                title: "Project Deleted",
                description: "Project deleted successfully",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            setProjects((prev) => prev.filter((items) => items.uuid !== id));
        } else {
            let error = result.error.message || "error Occured"
            toast({
                title: "Problem Deleting project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleUpdatedata = (item) => {
        setShowUpdateModal(true);
        setUpdatedata({ name: item.name, id: item.uuid, env_name: item.env_name })
    }

    const handlenewprojectcreation = () => {
        setShowModal(true);
        setProjectTitle({ name: '', env: "" })
    }

    const downloadLatestPdf = async (projectId) => {
        toast({
            title: "Downloading",
            description: "Downloading PDF",
            status: "info",
            duration: null,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        });
        var result = await getLatestProjectPdf(projectId);
        toast.closeAll();
        if (result.data) {
            downloadURI(
                "data:application/pdf;base64," + result.data.pdf,
                result.data.file
            );
            toast({
                title: "Downloading PDF.",
                description: "Download completed.",
                status: "success",
                duration: 2000,
            });
        } else {
            console.log(result);

            toast({
                title: "Download PDF Error",
                description: result.error.error,
                status: "error",
                duration: 2000,
            });
        }
    }

    const downloadLatestXML = async (projectId) => {
        toast({
            title: "Downloading",
            description: "Downloading XML",
            status: "info",
            duration: null,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        });
        var result = await getLatestProjectXML(projectId);
        toast.closeAll();
        if (result.data) {
            downloadFile(
                result.data.html,
                result.data.file,
                "html"
            );
            toast({
                title: "Downloading XML.",
                description: "Download completed.",
                status: "success",
                duration: 2000,
            });
        } else {
            toast({
                title: "Download XML Error",
                description: result.error.error,
                status: "error",
                duration: 2000,
            });
        }
    }

    const handleUpdateChange = (e) => {
        setUpdatedata({ ...updatedata, name: e.target.value });
    }

    // console.log(projects);

    return (
        <div className={styles.product_page_outer}>
            {projects.length < 1 ?
                <div className={styles.newproject}>
                    {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/newfileicon.svg"} alt='newfile' /> */}
                    <svg width="91" height="100" viewBox="0 0 91 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="66.4507" height="81.8191" rx="12" transform="matrix(0.938209 0.346069 0.338006 -0.941144 0.5 77.0039)" fill="var(--secondary-light)" />
                        <rect x="12.3281" y="9.02734" width="66.3458" height="81.9454" rx="12" fill="currentColor" />
                        <rect x="24.7695" y="59.4561" width="41.4661" height="6.30349" rx="3.15175" fill="white" />
                        <rect x="28.918" y="72.0625" width="33.1729" height="6.30349" rx="3.15175" fill="white" />
                        <g clip-path="url(#clip0_41_1967)">
                            <path d="M36.9485 27.676C38.0662 26.5142 39.4005 25.5889 40.8739 24.9537C42.3472 24.3185 43.9304 23.9861 45.5315 23.9758C47.1326 23.9656 48.7198 24.2776 50.201 24.8938C51.6822 25.51 53.0279 26.4181 54.1601 27.5655C55.2923 28.7129 56.1884 30.0767 56.7964 31.5778C57.4044 33.0789 57.7123 34.6874 57.7022 36.31C57.692 37.9327 57.3641 39.5371 56.7373 41.0303C56.1105 42.5234 55.1974 43.8756 54.051 45.0084C51.77 47.2411 48.715 48.4765 45.5439 48.4485C42.3728 48.4206 39.3394 47.1316 37.097 44.8591C34.8546 42.5866 33.5827 39.5124 33.5551 36.2987C33.5276 33.085 34.7466 29.9889 36.9497 27.6773L36.9485 27.676ZM46.7098 32.6658C46.7098 32.3407 46.5824 32.029 46.3555 31.7991C46.1287 31.5692 45.8211 31.4401 45.5004 31.4401C45.1796 31.4401 44.872 31.5692 44.6452 31.7991C44.4183 32.029 44.2909 32.3407 44.2909 32.6658V35.1171H41.8721C41.5513 35.1171 41.2437 35.2463 41.0169 35.4761C40.7901 35.706 40.6626 36.0178 40.6626 36.3428C40.6626 36.6679 40.7901 36.9797 41.0169 37.2095C41.2437 37.4394 41.5513 37.5685 41.8721 37.5685H44.2909V40.0199C44.2909 40.3449 44.4183 40.6567 44.6452 40.8866C44.872 41.1164 45.1796 41.2455 45.5004 41.2455C45.8211 41.2455 46.1287 41.1164 46.3555 40.8866C46.5824 40.6567 46.7098 40.3449 46.7098 40.0199V37.5685H49.1286C49.4494 37.5685 49.757 37.4394 49.9838 37.2095C50.2106 36.9797 50.3381 36.6679 50.3381 36.3428C50.3381 36.0178 50.2106 35.706 49.9838 35.4761C49.757 35.2463 49.4494 35.1171 49.1286 35.1171H46.7098V32.6658Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_41_1967">
                                <rect width="29.0263" height="29.4163" fill="white" transform="translate(30.9883 21.6348)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <button onClick={() => setShowModal(true)} className={styles.createtext}>
                        Create a Project
                    </button>
                </div> :
                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <p>Your Projects</p>
                        <button onClick={handlenewprojectcreation}>+ New Project</button>
                    </div>
                    <div className={styles.indivprojectlist}>
                        {projects ? projects.map((item, i) => (
                            <div key={i} className={styles.indivproject}>
                                {/* <input type='text' name='name' onChange={handleChange} value={item.name} style={{ background: "#f3f3f5" }}></input> */}
                                <div className={styles.projectContainer}>
                                    <div>
                                        <img className={styles.imageContainer} src={"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAIAAADTED8xAAADMElEQVR4nOzVwQnAIBQFQYXff81RUkQCOyDj1YOPnbXWPmeTRef+/3O/OyBjzh3CD95BfqICMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMO0TAAD//2Anhf4QtqobAAAAAElFTkSuQmCC"}></img>
                                    </div>
                                    <div className={styles.nameContainer}>
                                        <h1>{item.name}</h1>
                                        <div className={styles.templateContainer}
                                        ><div>{templateIcon()}</div>
                                            <p style={{ textWrap: "nowrap", overflow: "hidden" }} title={item.env_name} >
                                                {item.env_name}</p>

                                        </div><p style={{ fontSize: "14px", marginTop: "10px" }}>Created : {new Date(item.date).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })}</p>

                                        <Link to={`/${item.uuid}/`}>Go to editor</Link>
                                    </div>
                                </div>
                                <hr style={{ borderColor: "var(--border)", marginTop: "24px", borderWidth: "1px" }} />
                                <div className={styles.fileactionbtn}>
                                    <button title='Edit project' onClick={() => handleUpdatedata(item)}><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/edit.png"} alt='rename' /></button>
                                    <button title='Download latest PDF' onClick={() => downloadLatestPdf(item.uuid)}>{pdfIcon()}</button>
                                    <button title='Download latest XML' onClick={() => downloadLatestXML(item.uuid)}>{xmlIcon()}</button>
                                    {/*<button><img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/settings.png"} alt='settings' /></button> */}
                                    <button title='Delete project' onClick={() => handleDelete(item.uuid)}>
                                        {/* <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/delete.png"} alt='delete' /> */}
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_45_3546)">
                                                <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_45_3546">
                                                    <rect width="20" height="20" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        )) : ""}
                    </div>
                </div>
            }
            {/*MARK:creating new project */}
            {/*Modal for creating new project */}
            <Modal show={showmodal}>
                <div className={styles.modalouter}>
                    <div className={styles.modalheader}>
                        New Project
                    </div>
                    <form className={styles.formouter} method='POST' onSubmit={createFile}>
                        <div className={styles.inputdiv}>
                            <label>Project Title<span style={{
                                color: "var(--error)"
                            }}>*</span></label>
                            <input type='text'
                                name='project_name'
                                onChange={handleChange}
                                maxLength={50}
                                value={projectTitle.name}
                                placeholder='Enter Project Name' required />
                            <label>Choose Template</label>
                            <select value={projectTitle.env || ""} onChange={(e) => {
                                setProjectTitle({ ...projectTitle, env: e.target.value })
                            }}>
                                <option value="" disabled>Select an Environment</option>
                                {environment ? environment.map((env, id) => (
                                    <option key={id} value={env.uuid}>{env.name}</option>
                                )) : <option disabled>Create an Environment</option>}
                            </select>
                            {/* <input type='text' name='project_name' onChange={handleChange} value={projectTitle} placeholder='Enter Project Name' required /> */}
                        </div>
                        <div className={styles.actionbtn}>
                            <button className={styles.btn1} onClick={() => setShowModal(false)}>Cancel</button>
                            <button className={styles.btn2} type='submit'>Create</button>
                        </div>
                    </form>
                </div>
            </Modal >

            {/* Modal for Updating existing project */}
            <Modal show={showUpdateModal} >
                <div className={styles.modalouter}>
                    <div className={styles.modalheader}>
                        Update Project
                    </div>

                    <form className={styles.formouter} method='PUT' onSubmit={updateProject}>
                        <div className={styles.inputdiv}>

                            <label>Project Title<span style={{
                                color: "var(--error)"
                            }}>*</span></label>
                            <input type='text'
                                name='project_name'
                                onChange={handleUpdateChange}
                                value={updatedata.name}
                                placeholder='Enter Project Name' required />

                            <label>Choose Environment<span style={{
                                color: "var(--error)"
                            }}>*</span></label>
                            <select value={updatedata.env_name || ""} onChange={(e) => { setUpdatedata({ ...updatedata, env_name: e.target.value }) }}>
                                <option value="" disabled>Select an Environment</option>
                                {environment ? environment.map((env, id) => (
                                    <option key={id} value={env.uuid}>{env.name}</option>
                                )) : <option disabled>Create an Environment</option>}
                            </select>
                            {/* <input type='text' name='project_name' onChange={handleChange} value={projectTitle} placeholder='Enter Project Name' required /> */}
                        </div>
                        <div className={styles.actionbtn}>
                            <button className={styles.btn1} onClick={() => setShowUpdateModal(false)}>Cancel</button>
                            <button className={styles.btn2} type='submit'>Update</button>
                        </div>
                    </form>
                </div>
            </Modal>

        </div >
    )
}

export default Myproject